// Раздел «Личный кабинет»: своя страница инженера. ТОЛЬКО ЧТЕНИЕ.
//
// ЗАЧЕМ ОН НУЖЕН. Из непереносённых разделов портала 73 этот — самый массовый по числу
// живых людей: `/profile` открывают 119 человек, больше чем любой другой (рейтинг 69,
// задания процессов 43, акты 13; замер портала 28.07.2026, СЕРВИСЫ_остаток.md §8). В CRM понятия
// «своя страница» не было вовсе: зона видимости есть, личной страницы нет.
//
// ═════════════════════════════════════════════════════════════════════════════════
// РАЗДЕЛ ГОТОВ, НО ВЫКЛЮЧЕН, И ЭТО НЕ НЕДОРАБОТКА
// ═════════════════════════════════════════════════════════════════════════════════
//
// Данные кабинета лежат в трёх разделах, закрытых на ОДНУ УЧЁТКУ ВЛАДЕЛЬЦА: ведомость
// (баллы, бейджи, выплаты), инициативы, овертаймы и командировки. Так решено потому, что
// там заработок людей поимённо — тот же разряд данных, что касса и ФОТ.
//
// Личный кабинет — другой вопрос: не «покажи всех», а «покажи ЧЕЛОВЕКУ ЕГО СОБСТВЕННЫЕ
// данные». Технически это уже работает: ядро умеет отвечать по одному человеку, а кто
// именно спрашивает, знает BFF по подписанной сессии. Но ОТКРЫТЬ раздел — отдельное
// решение владельца, и оно ещё не принято. Поэтому экран живёт за флагом, ровно как единый
// вход за `CIR_ID_ENABLED`: выключенный раздел говорит словами, что он готов и чего ждёт,
// и не делает НИ ОДНОГО запроса за данными. Пустая таблица вместо этого была бы хуже
// всего: человек прочитал бы её как «мне ничего не начислено».
//
// ЧЕЛОВЕК ВИДИТ ТОЛЬКО СВОЁ, И ЭТО УСТРОЕНО НЕ ФИЛЬТРОМ. Ни один запрос этого экрана не
// содержит имени человека — ни в адресе, ни в параметрах: `engineer_bx` подставляет BFF
// из сессии, а то, что пришло из адресной строки, он обязан выбросить. Поэтому здесь нет
// ни поля «инженер», ни выпадающего списка людей, ни ссылки на чужой кабинет. Фильтр
// по умолчанию забывают снять; параметра, которого нет, забыть нельзя.
//
// ЧЕГО НА ЭТОМ ЭКРАНЕ НЕТ И НЕ БУДЕТ:
//   • платёжных реквизитов (телефон для перевода, банк) — в зеркало не переносятся;
//   • аватара — файл лежит в R2 портала, и его ручка помечена публично кэшируемой;
//   • штрафов, госномеров личных авто, геолокации, фото финансовых документов и чеков —
//     в зеркало не переносятся вовсе;
//   • кнопки «запросить выплату» — согласование живёт на портале 73, и вторая очередь
//     заявок означала бы, что кто-то получит деньги дважды или не получит вовсе;
//   • названий уровней и таблицы тарифов — это константы кода портала, в зеркале их нет,
//     и подписывать человеку ставку своей догадкой нельзя. Оговорку присылает сервер.

import { useState } from 'react'

import {
  useМоиБейджи, useМоиВыплаты, useМоиНачисления, useСводкаКабинета, useФлагКабинета,
} from '../api/profile'
import type {
  БейджСтрока, ВыплатаСтрока, НачислениеСтрока, СводкаКабинета,
} from '../api/profile'
import { QueryState } from '../components/QueryState'
import { fmtDate } from '../lib/format'
import {
  ИМЯ_СУЩНОСТИ, ПОРТАЛ_73_БАЛАНС, ПОРТАЛ_73_КАБИНЕТ, РАЗМЕР_СТРАНИЦЫ, бейджи, верификации,
  видНачисления, выплаты, графыРаботы, задания, записи, инициативы, кабинетПустой,
  командировки, незакрытое, отчёты, последняяАктивность, расхождениеБаланса, рубли,
  свежесть, серияДней, уровеньСловами, часыСловами, число,
} from '../lib/profile'

type Вкладка = 'summary' | 'accruals' | 'payouts' | 'badges'

export default function MyProfile() {
  const флаг = useФлагКабинета()
  const включён = !!флаг.data?.enabled && !!флаг.data?.linked
  const сводка = useСводкаКабинета(включён)
  const [вкладка, setВкладка] = useState<Вкладка>('summary')

  const св = свежесть(сводка.data?.freshness)

  return (
    <>
      <div className="page-head">
        <h1>Личный кабинет</h1>
        <span className="spacer" />
        <span className="hint">
          {св
            ? `обновлено ${св.age_min < 1 ? 'только что' : `${число(Math.round(св.age_min))} мин назад`}`
              + ` (позже всех — ${ИМЯ_СУЩНОСТИ[св.entity] ?? св.entity})`
            : 'только своё: сервер подставляет вас сам'}
        </span>
      </div>

      <QueryState isLoading={флаг.isLoading} error={флаг.error}>
        {!флаг.data?.enabled && <ЖдётРешения />}

        {флаг.data?.enabled && !флаг.data.linked && <НетПривязки />}

        {включён && (
          <QueryState isLoading={сводка.isLoading} error={сводка.error}>
            {сводка.data && !сводка.data.found && <НеИнженер данные={сводка.data} />}

            {сводка.data?.found && (
              <>
                <Шапка данные={сводка.data} />

                {/* Переключатель вкладок — обычный flex, а НЕ .filters: на телефоне
                    правило «.filters > * { width: 100% }» поставило бы кнопки в столбец
                    и заняло весь первый экран до того, ради чего его открыли. */}
                <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', marginBottom: 12 }}>
                  {([
                    ['summary', 'Сводка'],
                    ['accruals', `Начисления · ${число(сводка.data.money?.accruals)}`],
                    ['payouts', `Выплаты · ${число(сводка.data.money?.payouts)}`],
                    ['badges', `Бейджи · ${число(сводка.data.badges?.badges)}`],
                  ] as [Вкладка, string][]).map(([код, подпись]) => (
                    <button key={код} onClick={() => setВкладка(код)}
                            aria-pressed={вкладка === код}
                            style={{ fontWeight: вкладка === код ? 600 : 400,
                                     flex: '0 1 auto' }}>
                      {подпись}
                    </button>
                  ))}
                </div>

                {вкладка === 'summary' && <Сводка данные={сводка.data} />}
                {вкладка === 'accruals' && <Начисления />}
                {вкладка === 'payouts' && <Выплаты />}
                {вкладка === 'badges' && <Бейджи />}

                <Оговорки данные={сводка.data} />
              </>
            )}
          </QueryState>
        )}
      </QueryState>
    </>
  )
}

// ═══════════════════════════ выключенный раздел ═══════════════════════════

/**
 * Раздел готов и ждёт решения владельца. Говорим это словами и даём ссылку туда, где
 * человек посмотрит своё прямо сейчас: отправить его в тупик было бы хуже, чем не
 * показывать раздел вовсе.
 */
function ЖдётРешения() {
  return (
    <>
      <div className="notice">
        <b>Раздел готов, но ещё не открыт.</b> Данные вашего кабинета в зеркале уже есть, и
        сервер умеет показать их по одному человеку. Но лежат они в разделах, закрытых на
        одну учётку владельца: там заработок людей поимённо, тот же разряд данных, что
        касса и ФОТ. Открыть каждому его собственную страницу — отдельное решение
        владельца, и пока оно не принято, раздел выключен целиком.
      </div>
      <div className="card empty">
        <div className="empty-title">Пока смотрите свой кабинет на портале 73</div>
        <div className="empty-hint">
          Там всё то же: уровень, история начислений и выплат, бейджи. Вход туда отдельный.
          {' '}
          <a href={ПОРТАЛ_73_КАБИНЕТ} target="_blank" rel="noreferrer">Мой профиль</a>
          {' · '}
          <a href={ПОРТАЛ_73_БАЛАНС} target="_blank" rel="noreferrer">Все начисления</a>
        </div>
      </div>
    </>
  )
}

/**
 * Раздел включён, но эта учётка не привязана к сотруднику Bitrix. Отдельное состояние, а
 * не общая ошибка: причина у него ровно одна и она чинится одной строкой в учётке.
 */
function НетПривязки() {
  return (
    <div className="card empty">
      <div className="empty-title">Кабинет открыт, но вашу учётку не с кем сопоставить</div>
      <div className="empty-hint">
        Личный кабинет показывает данные конкретного сотрудника, а у этой учётки CRM нет
        привязки к сотруднику Bitrix. Без неё сервер не знает, чьи цифры показывать, и
        показывать чьи-нибудь он не станет. Привязку выставляет владелец в учётке.
      </div>
    </div>
  )
}

/** Раздел открыт, привязка есть, но инженером портала 73 человек не является. */
function НеИнженер({ данные }: { данные: СводкаКабинета }) {
  return (
    <div className="card empty">
      <div className="empty-title">Инженерной учётки на портале 73 у вас нет</div>
      <div className="empty-hint">
        {данные.why ?? ''} Это не ошибка: кабинет собирается из работ по судам, и у тех,
        кто их не ведёт, он пуст по существу. Если учётка на портале 73 у вас всё-таки
        есть — значит она не сопоставлена с вашим сотрудником в Bitrix.
      </div>
    </div>
  )
}

// ═══════════════════════════ шапка и сводка ═══════════════════════════

function Шапка({ данные }: { данные: СводкаКабинета }) {
  const д = данные.money
  const с = данные.streaks
  const расхождение = расхождениеБаланса(д)
  const висит = незакрытое(данные.work)

  return (
    <>
      <div className="card">
        <h2>{данные.person?.full_name ?? 'Вы'}</h2>
        <div className="hint">
          {уровеньСловами(данные.person?.level)}
          {данные.person?.is_active === false ? ' · учётка на портале отключена' : ''}
        </div>
      </div>

      <div className="tiles">
        <div className="tile">
          <div className="t-label">Заработано всего</div>
          <div className="t-sum">{рубли(д?.total_points)}</div>
        </div>
        <div className={`tile${Number(д?.available_points ?? 0) > 0 ? ' hot' : ''}`}>
          <div className="t-label">Доступно к выплате</div>
          <div className="t-sum">{рубли(д?.available_points)}</div>
        </div>
        <div className="tile">
          <div className="t-label">Уже выплачено</div>
          <div className="t-sum">{рубли(д?.paid_points)}</div>
        </div>
        <div className="tile">
          <div className="t-label">Серия</div>
          <div className="t-sum">{серияДней(с?.current_streak)}</div>
        </div>
      </div>

      {расхождение !== 0 && (
        <div className="notice err">
          <b>Баланс не сходится с журналом на {рубли(Math.abs(расхождение))}.</b> Это
          расхождение в самом зеркале, а не ошибка показа: сумма начислений в журнале и
          баланс на счёте разошлись. Считать правильным ни то, ни другое нельзя — скажите
          владельцу, он сверит с порталом.
        </div>
      )}

      {висит > 0 && (
        <div className="notice">
          У вас {висит === 1 ? 'незакрытая работа' : 'незакрытые работы'}:
          {' '}
          {Number(данные.work?.verif_open ?? 0) > 0
            && `${верификации(данные.work?.verif_open)} в работе`}
          {Number(данные.work?.verif_open ?? 0) > 0
            && Number(данные.work?.reports_open ?? 0) > 0 && ', '}
          {Number(данные.work?.reports_open ?? 0) > 0
            && `${отчёты(данные.work?.reports_open)} не сдано`}
          . Начисление приходит после одобрения, а не после заполнения.
        </div>
      )}
    </>
  )
}

function Сводка({ данные }: { данные: СводкаКабинета }) {
  if (кабинетПустой(данные)) {
    return (
      <div className="card empty">
        <div className="empty-title">Работ за вами в зеркале пока нет</div>
        <div className="empty-hint">
          Ни верификаций, ни отчётов, ни начислений. Это ответ про зеркало: если на портале
          73 у вас работы есть, значит они за другой учётной записью — скажите владельцу,
          он сверит привязку.
        </div>
      </div>
    )
  }

  const р = данные.work
  const и = данные.initiatives
  const о = данные.overtime
  const активность = последняяАктивность(данные.streaks, р)

  return (
    <>
      <div className="card">
        <h2>Работа по судам</h2>
        <div className="table-wrap cards">
          <table>
            <thead>
              <tr>
                <th>Что</th>
                <th className="num">Сколько</th>
                <th>Подробнее</th>
              </tr>
            </thead>
            <tbody>
              {графыРаботы(р).map(([подпись, n]) => (
                <tr key={подпись}>
                  <td data-label="Что">{подпись}</td>
                  <td className="num" data-label="Сколько">{число(n)}</td>
                  <td data-label="Подробнее">
                    {подпись === 'Верификации' && (
                      <span className="hint">
                        коротких одобрено {число(р?.verif_short_ok)}, полных
                        {' '}{число(р?.verif_full_ok)}, по своей инициативе
                        {' '}{число(р?.verif_initiative)}
                      </span>
                    )}
                    {подпись === 'Одобрено' && (
                      <span className="hint">
                        {р?.verif_last_at
                          ? `последняя правка ${fmtDate(р.verif_last_at)}`
                          : 'верификаций за вами нет'}
                      </span>
                    )}
                    {подпись === 'Отчёты по заявкам' && (
                      <span className="hint">одобрено {число(р?.reports_approved)}</span>
                    )}
                    {подпись === 'Акты на оборудование' && (
                      <span className="hint">
                        {р?.acts_last_date
                          ? `последний ${fmtDate(р.acts_last_date)}`
                          : 'дата последнего акта неизвестна'}
                      </span>
                    )}
                    {подпись === 'Задания процессов' && (
                      <span className="hint">
                        просрочено {число(р?.bp_overdue)}
                        {р?.bp_oldest_at
                          ? `, самое старое ждёт с ${fmtDate(р.bp_oldest_at)}` : ''}
                      </span>
                    )}
                  </td>
                </tr>
              ))}
              {!графыРаботы(р).length && (
                <tr>
                  <td colSpan={3} className="empty">
                    <div className="empty-title">Работ за вами не записано</div>
                    <div className="empty-hint">
                      Это про зеркало, а не про вас: если работы есть на портале, они за
                      другой учётной записью.
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        {подписьАктивности(активность)}
      </div>

      <div className="card">
        <h2>Инициативы</h2>
        {Number(и?.initiatives ?? 0) > 0 ? (
          <div className="tiles">
            <div className="tile">
              <div className="t-label">Инициатив за вами</div>
              <div className="t-sum">{инициативы(и?.initiatives)}</div>
            </div>
            <div className="tile">
              <div className="t-label">Причитается всего</div>
              <div className="t-sum">{рубли(и?.total_rub)}</div>
            </div>
            <div className={`tile${Number(и?.pending_rub ?? 0) > 0 ? ' hot' : ''}`}>
              <div className="t-label">Ещё не закрыто сделкой</div>
              <div className="t-sum">{рубли(и?.pending_rub)}</div>
            </div>
          </div>
        ) : (
          <div className="empty">
            <div className="empty-title">Инициатив за вами не записано</div>
            <div className="empty-hint">
              Инициатива — это работа, которую вы нашли сами, без заявки. Вознаграждение за
              неё считается по сделке, и сумму в сделку ставит не CRM.
            </div>
          </div>
        )}
      </div>

      <div className="card">
        <h2>Часы и поездки</h2>
        {Number(данные.overtime_n ?? 0) > 0 || Number(данные.trips_n ?? 0) > 0 ? (
          <div className="tiles">
            <div className="tile">
              <div className="t-label">Записей овертайма</div>
              <div className="t-sum">{записи(данные.overtime_n)}</div>
            </div>
            <div className="tile">
              <div className="t-label">Часов работы</div>
              <div className="t-sum">{часыСловами(о?.work_hours)}</div>
            </div>
            <div className="tile">
              <div className="t-label">Часов в дороге</div>
              <div className="t-sum">{часыСловами(о?.road_hours)}</div>
            </div>
            <div className="tile">
              <div className="t-label">Начислено за переработки</div>
              <div className="t-sum">{рубли(о?.sum_rub)}</div>
            </div>
            <div className="tile">
              <div className="t-label">Командировок</div>
              <div className="t-sum">{командировки(данные.trips_n)}</div>
            </div>
            <div className="tile">
              <div className="t-label">Согласовано записей</div>
              <div className="t-sum">{записи(о?.approved_n)}</div>
            </div>
          </div>
        ) : (
          <div className="empty">
            <div className="empty-title">Переработок и командировок за вами нет</div>
            <div className="empty-hint">
              Записи овертаймов живут в портале только два последних месяца — за более
              ранние смотрите ведомости региона у владельца.
            </div>
          </div>
        )}
      </div>
    </>
  )
}

/** Подпись про последнюю активность. Отдельной функцией, чтобы не плодить условия в JSX. */
function подписьАктивности(когда: string | null) {
  if (!когда) {
    return (
      <div className="hint">
        Последней активности в зеркале не записано. Порог, после которого портал роняет
        уровень за простой, в зеркало не переносится, и обещать срок здесь нечем.
      </div>
    )
  }
  return (
    <div className="hint">
      Последняя активность — {fmtDate(когда, true)}. Портал роняет уровень за долгий простой,
      но сам порог задан в его коде и в зеркало не переносится: сколько осталось, кабинет
      не считает, чтобы не назвать срок наугад.
    </div>
  )
}

// ═══════════════════════════ история начислений ═══════════════════════════

function Начисления() {
  const [старт, setСтарт] = useState(0)
  const запрос = useМоиНачисления(true, { start: старт, limit: РАЗМЕР_СТРАНИЦЫ })
  const итоги = запрос.data?.totals

  return (
    <QueryState isLoading={запрос.isLoading} error={запрос.error}>
      {итоги && (
        <div className="tiles">
          <div className="tile">
            <div className="t-label">Начислений</div>
            <div className="t-sum">{число(итоги.accruals)}</div>
          </div>
          <div className="tile">
            <div className="t-label">Сумма</div>
            <div className="t-sum">{рубли(итоги.points)}</div>
          </div>
          <div className="tile">
            <div className="t-label">Первое</div>
            <div className="t-sum">{fmtDate(итоги.first_at)}</div>
          </div>
          <div className="tile">
            <div className="t-label">Последнее</div>
            <div className="t-sum">{fmtDate(итоги.last_at)}</div>
          </div>
        </div>
      )}

      {!!итоги?.unparsed_kind && (
        <div className="notice">
          У {число(итоги.unparsed_kind)} начислений вид разобрать не удалось: портал пишет
          причину строкой, без кода, и формулировка поменялась. Сумма при этом верна —
          неизвестен только разряд.
        </div>
      )}

      <ТаблицаНачислений строки={запрос.data?.rows ?? []} />
      <Постраничник всего={запрос.data?.total ?? 0} старт={старт} setСтарт={setСтарт} />
    </QueryState>
  )
}

function ТаблицаНачислений({ строки }: { строки: НачислениеСтрока[] }) {
  return (
    <div className="table-wrap cards">
      <table>
        <thead>
          <tr>
            <th>Когда</th>
            <th>За что</th>
            <th>Вид</th>
            <th className="num">Сумма</th>
          </tr>
        </thead>
        <tbody>
          {строки.map((r) => (
            <tr key={r.d1_id}>
              <td data-label="Когда">
                <div className="nowrap">{fmtDate(r.created_at)}</div>
                <div className="hint">{r.period ?? ''}</div>
              </td>
              <td data-label="За что">{r.reason ?? '—'}</td>
              <td data-label="Вид"><span className="hint">{видНачисления(r.kind)}</span></td>
              <td className="num" data-label="Сумма">{рубли(r.points)}</td>
            </tr>
          ))}
          {!строки.length && (
            <tr>
              <td colSpan={4} className="empty">
                <div className="empty-title">Начислений пока нет</div>
                <div className="empty-hint">
                  Начисление приходит после того, как верификацию или отчёт одобрили, а не
                  после того, как их заполнили.
                </div>
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  )
}

// ═══════════════════════════ выплаты ═══════════════════════════

function Выплаты() {
  const [старт, setСтарт] = useState(0)
  const запрос = useМоиВыплаты(true, { start: старт, limit: РАЗМЕР_СТРАНИЦЫ })
  const итоги = запрос.data?.totals
  const строки = запрос.data?.rows ?? []
  const несходится = строки.filter((r) => Number(r.rub_minus_points ?? 0) !== 0).length

  return (
    <QueryState isLoading={запрос.isLoading} error={запрос.error}>
      {итоги && (
        <div className="tiles">
          <div className="tile">
            <div className="t-label">Выплат</div>
            <div className="t-sum">{число(итоги.payouts)}</div>
          </div>
          <div className="tile">
            <div className="t-label">Выплачено</div>
            <div className="t-sum">{рубли(итоги.amount_rub)}</div>
          </div>
          <div className="tile">
            <div className="t-label">Периодов</div>
            <div className="t-sum">{число(итоги.periods)}</div>
          </div>
          <div className="tile">
            <div className="t-label">Последняя</div>
            <div className="t-sum">{fmtDate(итоги.last_at)}</div>
          </div>
        </div>
      )}

      {несходится > 0 && (
        <div className="notice err">
          У {выплаты(несходится)} рубли не совпали со списанными баллами. Курс портала
          — балл за рубль, и расхождение здесь означает, что в источнике одно из двух чисел
          поправили руками. Скажите владельцу.
        </div>
      )}

      <ТаблицаВыплат строки={строки} />
      <Постраничник всего={запрос.data?.total ?? 0} старт={старт} setСтарт={setСтарт} />

      <div className="hint" style={{ marginTop: 8 }}>
        Заявку на выплату подают на портале 73 — согласование живёт там.
        {' '}
        <a href={ПОРТАЛ_73_БАЛАНС} target="_blank" rel="noreferrer">Открыть портал</a>
      </div>
    </QueryState>
  )
}

function ТаблицаВыплат({ строки }: { строки: ВыплатаСтрока[] }) {
  return (
    <div className="table-wrap cards">
      <table>
        <thead>
          <tr>
            <th>Когда</th>
            <th>Период</th>
            <th className="num">Сумма</th>
            <th>Кто провёл</th>
            <th>Комментарий</th>
          </tr>
        </thead>
        <tbody>
          {строки.map((r) => (
            <tr key={r.d1_id}>
              <td data-label="Когда"><div className="nowrap">{fmtDate(r.created_at)}</div></td>
              <td data-label="Период">{r.period ?? '—'}</td>
              <td className="num" data-label="Сумма">
                {рубли(r.amount_rub)}
                {Number(r.rub_minus_points ?? 0) !== 0 && (
                  <div className="hint">
                    списано баллами {число(r.points_paid)}
                  </div>
                )}
              </td>
              <td data-label="Кто провёл">{r.created_by_name ?? '—'}</td>
              <td data-label="Комментарий">{r.notes ?? '—'}</td>
            </tr>
          ))}
          {!строки.length && (
            <tr>
              <td colSpan={5} className="empty">
                <div className="empty-title">Выплат пока не было</div>
                <div className="empty-hint">
                  Заработанное копится на счёте, пока вы не подадите заявку на портале 73.
                </div>
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  )
}

// ═══════════════════════════ бейджи ═══════════════════════════

function Бейджи() {
  const [старт, setСтарт] = useState(0)
  const запрос = useМоиБейджи(true, { start: старт, limit: РАЗМЕР_СТРАНИЦЫ })
  const итоги = запрос.data?.totals

  return (
    <QueryState isLoading={запрос.isLoading} error={запрос.error}>
      {итоги && (
        <div className="tiles">
          <div className="tile">
            <div className="t-label">Бейджей получено</div>
            <div className="t-sum">{бейджи(итоги.badges)}</div>
          </div>
          <div className="tile">
            <div className="t-label">Цена по каталогу</div>
            <div className="t-sum">{рубли(итоги.bonus_points)}</div>
          </div>
          <div className="tile">
            <div className="t-label">Первый</div>
            <div className="t-sum">{fmtDate(итоги.first_at)}</div>
          </div>
          <div className="tile">
            <div className="t-label">Последний</div>
            <div className="t-sum">{fmtDate(итоги.last_at)}</div>
          </div>
        </div>
      )}

      {запрос.data?.bonus_points_note && (
        <div className="notice">{запрос.data.bonus_points_note}. Сколько начислили
        именно вам, смотрите на вкладке «Начисления».</div>
      )}

      {!!итоги?.unknown_badge && (
        <div className="notice err">
          {число(итоги.unknown_badge)} бейджей выданы, а в каталоге портала их нет. Название
          и цену показать нечем — это расхождение в источнике.
        </div>
      )}

      <ТаблицаБейджей строки={запрос.data?.rows ?? []} />
      <Постраничник всего={запрос.data?.total ?? 0} старт={старт} setСтарт={setСтарт} />
    </QueryState>
  )
}

function ТаблицаБейджей({ строки }: { строки: БейджСтрока[] }) {
  return (
    <div className="table-wrap cards">
      <table>
        <thead>
          <tr>
            <th>Бейдж</th>
            <th>За что дают</th>
            <th>Получен</th>
            <th className="num">Цена по каталогу</th>
          </tr>
        </thead>
        <tbody>
          {строки.map((r) => (
            <tr key={r.d1_id}>
              <td data-label="Бейдж">
                {r.icon ? `${r.icon} ` : ''}{r.name ?? r.code ?? '—'}
                {!r.name && r.code && <div className="hint">названия в каталоге нет</div>}
              </td>
              <td data-label="За что дают">{r.description ?? '—'}</td>
              <td data-label="Получен">
                <div className="nowrap">{fmtDate(r.earned_at)}</div>
              </td>
              <td className="num" data-label="Цена по каталогу">{рубли(r.bonus_points)}</td>
            </tr>
          ))}
          {!строки.length && (
            <tr>
              <td colSpan={4} className="empty">
                <div className="empty-title">Бейджей пока нет</div>
                <div className="empty-hint">
                  Первые бейджи приходят сами: за вход несколько дней подряд, за пройденный
                  курс, за первую верификацию.
                </div>
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  )
}

// ═══════════════════════════ общее ═══════════════════════════

function Постраничник({ всего, старт, setСтарт }: {
  всего: number
  старт: number
  setСтарт: (n: number) => void
}) {
  if (всего <= РАЗМЕР_СТРАНИЦЫ) return null
  const конец = Math.min(старт + РАЗМЕР_СТРАНИЦЫ, всего)
  return (
    <div className="pager">
      <button disabled={старт === 0}
              onClick={() => setСтарт(Math.max(0, старт - РАЗМЕР_СТРАНИЦЫ))}>
        Назад
      </button>
      <span className="muted">{число(старт + 1)}–{число(конец)} из {число(всего)}</span>
      <button disabled={конец >= всего} onClick={() => setСтарт(старт + РАЗМЕР_СТРАНИЦЫ)}>
        Дальше
      </button>
    </div>
  )
}

/**
 * Оговорки о неполноте — с сервера. Печатаем их все и не выбираем «важные»: выбирать
 * значило бы решать за человека, какая часть правды про его деньги ему не нужна.
 */
function Оговорки({ данные }: { данные: СводкаКабинета }) {
  if (!данные.notes?.length) return null
  return (
    <div className="card">
      <h2>Чего кабинет не знает</h2>
      <ul>
        {данные.notes.map((с) => <li key={с} className="hint">{с}</li>)}
      </ul>
      <div className="hint">
        Всё, что здесь перечислено, есть на портале 73 и туда же подаются заявки:
        {' '}
        <a href={ПОРТАЛ_73_КАБИНЕТ} target="_blank" rel="noreferrer">Мой профиль</a>.
        {' '}Задания процессов и работы по судам смотрите в разделах CRM —
        {' '}{задания(данные.work?.bp_live)} ждут вас прямо сейчас.
      </div>
    </div>
  )
}
